import { render, staticRenderFns } from "./DepositOld.vue?vue&type=template&id=1a70390e&scoped=true"
import script from "./DepositOld.vue?vue&type=script&lang=js"
export * from "./DepositOld.vue?vue&type=script&lang=js"
import style0 from "./DepositOld.vue?vue&type=style&index=0&id=1a70390e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a70390e",
  null
  
)

export default component.exports